module.exports = __webpack_public_path__ + "img/mos-swiper-pad2.7f49589e.png";